import { findArray } from 'helpers/utils';
import MirsTable from 'components/general/table/Table.js';
import Competitor from 'components/presentation/Competitor';
import Noc from 'components/presentation/Noc';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop } from "@fortawesome/free-solid-svg-icons";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getEvent } from "helpers/rsc"
import { useViewport } from 'components/general/useViewPort';
import SportCode from 'components/common/SportCode';

const PlayerStatisticsTeam = ({ data, stats, results }) => {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
  const tableColumns = useMemo(() =>
    [
      {
        id: 'TeamTotals',
        Header: <Label data={'HeaderTeamStatistics'} />,
        accessor: 'code',
        className: 'text-start w-30',
        Cell: (props) => {
          return (
            <Label data={props.value} sport={mirs_discipline} />
          )
        }
      },
      {
        id: 'Home_Match1',
        Header: <>TM</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_TOT = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === 'TOT') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';

          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_TOT?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['TOT'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'TOT')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
              return (<TeamStatsType3 value={props?.value}
                score={teamValue}
              />)
            default:
              return (<TeamStatsType1 value={teamValue_TOT?.value} />)
          }
        },
      },
      {
        id: 'Home_Game1',
        Header: <><Label data='HeaderAbreviateMatch' /> 1</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_G1 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '1') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';

          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G1?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G1'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G1')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
              return (<TeamStatsType3 value={props?.value}
                score={teamValue}
              />)
            default:
              return (<TeamStatsType1 value={teamValue_G1?.value} />)
          }
        },
      },

      {
        id: 'Home_Game2',
        Header: <><Label data='HeaderAbreviateMatch' /> 2</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_G2 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '2') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G2?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G2'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G2')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G2?.value} />)
          }
        },
      },
      {
        id: 'Home_Game3',
        Header: <><Label data='HeaderAbreviateMatch' /> 3</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_G3 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '3') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G3?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G3'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G3')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G3?.value} />)
          }
        },
      },
      {
        id: 'Home_Game4',
        Header: <><Label data='HeaderAbreviateMatch' /> 4</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_G4 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '4') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G4?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G4'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G4')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G4?.value} />)
          }
        },
      },
      {
        id: 'Home_Game5',
        Header: <><Label data='HeaderAbreviateMatch' /> 5</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_G5 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '5') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G5?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G5'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G5')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G5?.value} />)
          }
        },
      },
      {
        id: 'Home_Match2',
        Header: <>TM</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_TOT = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === 'TOT') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';


          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_TOT?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['TOT'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'TOT')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
              return (<TeamStatsType3 value={props?.value}
                score={teamValue}
              />)
            default:
              return (<TeamStatsType1 value={teamValue_TOT?.value} />)
          }
        },
      },
      {
        id: 'Away_Game1',
        Header: <><Label data='HeaderAbreviateMatch' /> 1</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_G1 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '1') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G1?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G1'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G1')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G1?.value} />)
          }
        },
      },
      {
        id: 'Away_Game2',
        Header: <><Label data='HeaderAbreviateMatch' /> 2</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_G2 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '2') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G2?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G2'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G2')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G2?.value} />)
          }
        },
      },
      {
        id: 'Away_Game3',
        Header: <><Label data='HeaderAbreviateMatch' /> 3</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_G3 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '3') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G3?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G3'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G3')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G3?.value} />)
          }
        },
      },
      {
        id: 'Away_Game4',
        Header: <><Label data='HeaderAbreviateMatch' /> 4</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_G4 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '4') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G4?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G4'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G4')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G4?.value} />)
          }
        },
      },
      {
        id: 'Away_Game5',
        Header: <><Label data='HeaderAbreviateMatch' /> 5</>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_G5 = team?.statsItems?.find(filter => (filter.pos === undefined || filter.pos === '5') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_G5?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['G5'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'G5')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
            default:
              return (<TeamStatsType1 value={teamValue_G5?.value} />)
          }
        },
      },
    ], [data]
  )

  const tableColumnsSM = useMemo(() =>
    [
      {
        id: 'TeamTotals',
        Header: <Label data={'HeaderTeamStatistics'} />,
        accessor: 'code',
        className: 'text-start w-30',
        Cell: (props) => {
          return (
            <Label data={props.value} sport={mirs_discipline} />
          )
        }
      },
      {
        id: 'Home_Match1',
        Header: <></>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [1] })
          let teamValue_TOT = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === 'TOT') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';


          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_TOT?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['TOT'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'TOT')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
              return (<TeamStatsType3 value={props?.value}
                score={teamValue}
              />)
            default:
              return (<TeamStatsType1 value={teamValue_TOT?.value} />)
          }
        },
      },
      {
        id: 'Away_Match1',
        Header: <></>,
        headerClassName: "w-3 text-center",
        accessor: 'code',
        className: 'text-center',
        Cell: (props) => {
          let team = findArray(data.items, { startSortOrder: [2] })
          let teamValue_TOT = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === 'TOT') && filter.code === props.value);
          let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';


          switch (component) {
            case "type2":
              return (<TeamStatstype2 value={teamValue_TOT?.value}
                lost={findArray(team?.statsItems, { code: ['CHALLENGE_LOST'], pos: ['TOT'] }).value}
              />)
            case "type3":
              let teamStats = team?.statsItems?.filter(filter => filter.code === props.value);
              let teamValue = []
              teamStats?.forEach(item => {
                let res = item.extendedStatsItems?.find(filter => filter.pos === 'TOT')
                if (res !== undefined) {
                  teamValue.push(<TeamStatsType3 value={item?.value}
                    score={res.value}
                  />)
                }
              }
              )
              return (
                teamValue.map(item => <div>{item}</div>)
              )
              return (<TeamStatsType3 value={props?.value}
                score={teamValue}
              />)
            default:
              return (<TeamStatsType1 value={teamValue_TOT?.value} />)
          }
        },
      },
    ]
  )


  let hiddenColumns = []

  const { breakPoint } = useViewport();
  let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns

  return (
    <>
      <div className='d-flex align-items-center justify-content-center'>
        <div className='w-40'></div>
        <div className='d-flex w-30 align-items-center justify-content-center text-center'>
          {breakPoint !== 'sm' && breakPoint !== 'xs' && <Noc {...findArray(data.items, { startSortOrder: [1] })?.participant?.organisation} />}
          <strong><Competitor hidePicture={true} hideNoc={false} {...findArray(data.items, { startSortOrder: [1] })?.participant} /></strong>
        </div>
        <div className='d-flex w-30 align-items-center justify-content-center text-center'>
          {breakPoint !== 'sm' && breakPoint !== 'xs' && <Noc {...findArray(data.items, { startSortOrder: [2] })?.participant?.organisation} />}
          <strong><Competitor hidePicture={true} hideNoc={false} {...findArray(data.items, { startSortOrder: [2] })?.participant} /></strong>
        </div>
      </div>
      <MirsTable
        id={`mirs-table-team-statistics-${mirs_rsc}`}
        data={stats}
        columns={columns}
        hiddenColumns={hiddenColumns}
        showLoading={false}
      />
      {getEvent(mirs_rsc) === 'TEAM--------------'
        ? <></>
        : <><div className='d-flex align-items-center justify-content-center'>
          <div className='w-40'><Label data={'HeaderHandedness/Grip'} sport={'TTE'} /></div>
          <div className='d-flex w-30 align-items-center justify-content-center text-center'>
            {findArray(data.items, { startSortOrder: [1] }).teamAthletes.length > 1
              ? <>
                {breakPoint === 'sm' || breakPoint === 'xs'
                  ? findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value
                  : <SportCode discipline={mirs_discipline} entity='@Hand' code={findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value} />
                }/
                <SportCode discipline={mirs_discipline} entity='@Grip' code={findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['GRIP'] }).eue_value} /> - {breakPoint === 'sm' || breakPoint === 'xs'
                  ? findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes[1].eventUnitEntries, { eue_code: ['HAND'] }).eue_value
                  : <SportCode discipline={mirs_discipline} entity='@Hand' code={findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes[1].eventUnitEntries, { eue_code: ['HAND'] }).eue_value} />
                }/
                <SportCode discipline={mirs_discipline} entity='@Grip' code={findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes[1].eventUnitEntries, { eue_code: ['GRIP'] }).eue_value} />
              </>

              : <>{breakPoint === 'sm' || breakPoint === 'xs'
                ? findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value
                : <SportCode discipline={mirs_discipline} entity='@Hand' code={findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value} />
              }/
                <SportCode discipline={mirs_discipline} entity='@Grip' code={findArray(findArray(data.items, { startSortOrder: [1] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['GRIP'] }).eue_value} /></>
            }
          </div>
          <div className='d-flex w-30 align-items-center justify-content-center text-center'>
            {findArray(data.items, { startSortOrder: [1] }).teamAthletes.length > 1
              ? <>
                {breakPoint === 'sm' || breakPoint === 'xs'
                  ? findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value
                  : <SportCode discipline={mirs_discipline} entity='@Hand' code={findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value} />
                }/
                <SportCode discipline={mirs_discipline} entity='@Grip' code={findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['GRIP'] }).eue_value} /> - {breakPoint === 'sm' || breakPoint === 'xs'
                  ? findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes[1].eventUnitEntries, { eue_code: ['HAND'] }).eue_value
                  : <SportCode discipline={mirs_discipline} entity='@Hand' code={findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes[1].eventUnitEntries, { eue_code: ['HAND'] }).eue_value} />
                }/
                <SportCode discipline={mirs_discipline} entity='@Grip' code={findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes[1].eventUnitEntries, { eue_code: ['GRIP'] }).eue_value} />
              </>

              : <>{breakPoint === 'sm' || breakPoint === 'xs'
                ? findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value
                : <SportCode discipline={mirs_discipline} entity='@Hand' code={findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['HAND'] }).eue_value} />
              }/
                <SportCode discipline={mirs_discipline} entity='@Grip' code={findArray(findArray(data.items, { startSortOrder: [2] }).teamAthletes?.find(x=> x !== undefined).eventUnitEntries, { eue_code: ['GRIP'] }).eue_value} /></>
            }
          </div>
        </div></>
      }

    </>
  )
}

// SE MUESTRA SOLO UN VALOR '25'
function TeamStatsType1({ value }) {
  return (
    <>
      {value !== undefined ? value : ''}
    </>
  )
}
// SE MUESTRAN DOS VALORS '2/5' para Successful / Unsuccessful challenges
function TeamStatstype2({ value, lost }) {
  return (
    <>
      {value !== undefined ? value + '/' + lost : ''}
    </>
  )
}
// SE MUESTRAN DOS VALORES 'YC (10-5)' 
function TeamStatsType3({ value, score }) {

  const icons = [{
    icon: faStop,
    colour: 'icon-yellow',
    type: 'YC'
  },
  {
    icon: faStop,
    colour: 'icon-red',
    type: 'RC'
  },
  {
    icon: faStop,
    colour: 'icon-black',
    type: 'BC'
  }
  ]
  let icon = icons.find(item => item.type === value)
  return (

    value && <div><span className='w-20'><FontAwesomeIcon className={`${icon?.colour}`} icon={icon?.icon} /></span> ({score})</div>

  )
}


export default PlayerStatisticsTeam;